import { render } from "./q&a.vue?vue&type=template&id=09b7224a"
import script from "./q&a.vue?vue&type=script&lang=js"
export * from "./q&a.vue?vue&type=script&lang=js"

import "./q&a.vue?vue&type=style&index=0&id=09b7224a&lang=scss"

import exportComponent from "E:\\code\\libra-3rd\\yuexinting-putuo\\yxt-web-3.0\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.4.38_vue@3.4.38_typescript@4.1.6__webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__